import { connect, ResolveThunks } from "react-redux";
import { TermsContent } from "components/legal/TermsContent";

interface StateProps {}

interface DispatchProps {}

type Props = StateProps & ResolveThunks<DispatchProps>;

const TermsPage = (_props: Props): JSX.Element => {
  return (
    <div className="p-4 md:p-6 text-ink-2 flex flex-col gap-y-2 max-w-prose">
      <TermsContent />
    </div>
  );
};

export default connect()(TermsPage);
